import { i18n } from "@/config/i18n";

export default {
  name: 'Invest',
  data() {
    return {
      activeFaq: null,
      forWhomCards: [
        { titleKey: 'home.forWhom1Title', descKey: 'home.forWhom1Desc', tagKey: 'home.forWhom1Tag', icon: 'fas fa-user' },
        { titleKey: 'home.forWhom2Title', descKey: 'home.forWhom2Desc', tagKey: 'home.forWhom2Tag', icon: 'fas fa-briefcase' },
        { titleKey: 'home.forWhom3Title', descKey: 'home.forWhom3Desc', tagKey: 'home.forWhom3Tag', icon: 'fas fa-seedling' },
        { titleKey: 'invest.forWhom4Title', descKey: 'invest.forWhom4Desc', tagKey: 'invest.forWhom4Tag', icon: 'fas fa-chart-bar' },
      ],
      pricingRows: [
        { titleKey: 'home.pricing1Title', descKey: 'home.pricing1Desc', value: '10%', noteKey: 'home.pricing1Note', featured: true },
        { titleKey: 'home.pricing2Title', descKey: 'home.pricing2Desc', value: '0%', noteKey: 'home.pricing2Note', featured: false },
        { titleKey: 'home.pricing3Title', descKey: 'home.pricing3Desc', value: '8$ = 200k', noteKey: 'home.pricing3Note', featured: false },
        { titleKey: 'home.pricing4Title', descKey: 'home.pricing4Desc', value: 'T+0', noteKey: 'home.pricing4Note', featured: false },
      ],
      commitments: [
        { icon: 'fas fa-eye', titleKey: 'invest.commit1Title', descKey: 'invest.commit1Desc' },
        { icon: 'fas fa-unlock-alt', titleKey: 'invest.commit2Title', descKey: 'invest.commit2Desc' },
        { icon: 'fas fa-headset', titleKey: 'invest.commit3Title', descKey: 'invest.commit3Desc' },
      ],
      faqs: [
        { qKey: 'home.faq1Q', aKey: 'home.faq1A' },
        { qKey: 'home.faq2Q', aKey: 'home.faq2A' },
        { qKey: 'home.faq3Q', aKey: 'home.faq3A' },
        { qKey: 'home.faq4Q', aKey: 'home.faq4A' },
        { qKey: 'home.faq5Q', aKey: 'home.faq5A' },
      ],
    };
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
  methods: {
    t(key) { return i18n.global.t(key); },
    toggleFaq(i) { this.activeFaq = this.activeFaq === i ? null : i; },
    goToContact() { this.$router.push('/contact'); },
  },
};
